import Helper from './Helper';
import Lightbox from './Lightbox';
import LinkTargetHandler from './LinkTargetHandler';

class Insights {
  constructor() {
    this.insight = document.querySelector('[class*="insight-"]');
    if(this.insight){
      const restUrl = this.insight.dataset.restUrl;
      let html = "";
      this.getData(restUrl).then((posts) => {
        // console.log(posts)
        // posts = posts.parse();
        posts.forEach(post => {
          // console.log(post);
          html += this.buildHtml(post);
        });
        this.placeInDom(html);
        this.bindEvents();
      });
    }
  }

  bindEvents(){
    let lightbox = new Lightbox({
      toggleSelector: '.insight-teaser',
      isImageLightbox: false
    });
  }

  buildHtml(post){
    let html = `<article class="insight-teaser"
      style="background-image: url('${post.meta['wp_img-cf_featuredImage']}')">
      <span class="insight-teaser__title">${post.meta['wp_cf_prettyTitle']}</span>
      <input type="hidden" class="insight-teaser__content" value="${Helper.escapeHTML(post.content)}">
    </article>`;
    return html;
  }

  getData(restUrl) {
    return fetch(restUrl, {
      headers: {
        'X-WP-Token': NSContext.token
      }})
      .then((response) => {
        return response.json();
      })
  }

  placeInDom(html){
    var e = document.createElement('section');
    e.innerHTML = html;
    e.classList.add('ns-insights');
    this.insight.appendChild(e);
    // console.log('place in dom')
    new LinkTargetHandler({
      linkSelector: '.js-target-blank a'
    });
  }

} export default Insights;
